import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row m-0" }
const _hoisted_2 = { class: "text-input px-0 col-lg-auto col-md-auto col-sm-12 col-xs-12 mb-4 me-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "item-label d-block" }, "Address line 1", -1)
const _hoisted_4 = {
  key: 2,
  class: "mt-1 item-validation-error"
}
const _hoisted_5 = { class: "row m-0" }
const _hoisted_6 = { class: "text-input px-0 col-lg-auto col-md-auto col-sm-12 col-xs-12 mb-4 me-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "item-label d-block" }, "Address line 2", -1)
const _hoisted_8 = {
  key: 0,
  class: "mt-1 item-validation-error"
}
const _hoisted_9 = {
  key: 0,
  class: "row m-0"
}
const _hoisted_10 = { class: "text-input px-0 col-lg-auto col-md-auto col-sm-12 col-xs-12 mb-4 me-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "item-label d-block" }, "Address line 3", -1)
const _hoisted_12 = {
  key: 0,
  class: "mt-1 item-validation-error"
}
const _hoisted_13 = { class: "row m-0" }
const _hoisted_14 = {
  key: 0,
  class: "text-input px-0 col-lg-auto col-md-auto col-sm-6 col-xs-6 mb-4 me-2"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "item-label d-block" }, "Suburb", -1)
const _hoisted_16 = {
  key: 0,
  class: "mt-1 item-validation-error"
}
const _hoisted_17 = { class: "text-input px-0 col-lg-auto col-md-auto col-sm-6 col-xs-6 mb-4 me-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "item-label d-block" }, "City/Town", -1)
const _hoisted_19 = {
  key: 0,
  class: "mt-1 item-validation-error"
}
const _hoisted_20 = { class: "row m-0" }
const _hoisted_21 = { class: "text-input px-0 col-lg-auto col-md-auto col-sm-6 col-xs-6 mb-4 me-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "item-label d-block" }, "Postcode/ZIP code", -1)
const _hoisted_23 = {
  key: 0,
  class: "mt-1 item-validation-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchDropdown = _resolveComponent("SearchDropdown")!
  const _component_TextInputSmall = _resolveComponent("TextInputSmall")!
  const _component_SelectInput = _resolveComponent("SelectInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_ctx.showFieldsForOverseasAddress)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.addressDetails.address1) = $event)),
              class: _normalizeClass(["item-body ins-form-control-double ps-2 d-block", { 'validation-error': _ctx.readError('address1') }])
            }, null, 2)), [
              [_vModelText, _ctx.addressDetails.address1]
            ])
          : (_openBlock(), _createBlock(_component_SearchDropdown, {
              key: 1,
              value: _ctx.addressDetails.address1,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.addressDetails.address1) = $event)),
              "search-address": true,
              class: "px-2 mx-1",
              "validation-error": _ctx.readError('address1'),
              options: _ctx.searchResults,
              "is-loading": _ctx.isLoading,
              onSearchQuery: _ctx.searchAndValidateAddress
            }, null, 8, ["value", "validation-error", "options", "is-loading", "onSearchQuery"])),
        (_ctx.showFieldsForOverseasAddress)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.readError('address1')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addressDetails.address2) = $event)),
          class: _normalizeClass(["item-body ins-form-control-double ps-2 d-block", { 'validation-error': _ctx.readError('address2') }])
        }, null, 2), [
          [_vModelText, _ctx.addressDetails.address2]
        ]),
        (_ctx.readError('address2'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.readError('address2')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.showFieldsForOverseasAddress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addressDetails.address3) = $event)),
              class: _normalizeClass(["item-body ins-form-control-double ps-2 d-block", { 'validation-error': _ctx.readError('address3') }])
            }, null, 2), [
              [_vModelText, _ctx.addressDetails.address3]
            ]),
            (_ctx.readError('address3'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.readError('address3')), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      (!_ctx.showFieldsForOverseasAddress)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _hoisted_15,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.addressDetails.address3) = $event)),
              class: _normalizeClass(["item-body ins-form-control ps-2 d-block", { 'validation-error': _ctx.readError('address3') }])
            }, null, 2), [
              [_vModelText, _ctx.addressDetails.address3]
            ]),
            (_ctx.readError('address3'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.readError('address3')), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.addressDetails.city) = $event)),
          class: _normalizeClass(["item-body ins-form-control ps-2 d-block", { 'validation-error': _ctx.readError('city') }])
        }, null, 2), [
          [_vModelText, _ctx.addressDetails.city]
        ]),
        (_ctx.readError('city'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.readError('city')), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showFieldsForOverseasAddress)
        ? (_openBlock(), _createBlock(_component_TextInputSmall, {
            key: 1,
            value: _ctx.addressDetails.state,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.addressDetails.state) = $event)),
            title: 'State/Province/Region',
            class: "px-0 mb-4 me-2",
            "validation-error": _ctx.readError('state')
          }, null, 8, ["value", "validation-error"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.addressDetails.postCode) = $event)),
          class: _normalizeClass(["item-body ins-form-control ps-2 d-block", { 'validation-error': _ctx.readError('postCode') }])
        }, null, 2), [
          [_vModelText, _ctx.addressDetails.postCode]
        ]),
        (_ctx.readError('postCode'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.readError('postCode')), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showFieldsForOverseasAddress)
        ? (_openBlock(), _createBlock(_component_SelectInput, {
            key: 0,
            value: _ctx.addressDetails.country,
            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.addressDetails.country) = $event)),
            options: _ctx.countries,
            title: 'Country',
            class: "col-lg-auto col-md-auto col-sm-6 col-xs-6 px-0 mb-4 me-2",
            "validation-error": _ctx.readError('country')
          }, null, 8, ["value", "options", "validation-error"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}